import React from 'react';
import { Button } from 'antd';
import { CloseOutlined, LeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const staticAdverts = [
  { title: 'Master AI Today!', text: 'Join our tuition-free AI course.', buttonText: 'Learn Now', path: '/courses', gradient: 'linear-gradient(45deg, #13c2c2, #08979c)', hoverGradient: 'linear-gradient(45deg, #08979c, #056f73)' },
  { title: 'AI Hackathon', text: 'Compete in real-world AI challenges.', buttonText: 'Join Now', path: '/challenges', gradient: 'linear-gradient(45deg, #fa8c16, #d46b08)', hoverGradient: 'linear-gradient(45deg, #d46b08, #ad4e00)' },
  { title: 'Find AI Jobs', text: 'Discover AI career opportunities.', buttonText: 'Explore Jobs', path: '/jobs', gradient: 'linear-gradient(45deg, #722ed1, #531dab)', hoverGradient: 'linear-gradient(45deg, #531dab, #39157a)' },
];

const companyAdverts = [
  { title: 'Partner with Google', text: 'Collaborate on AI projects.', buttonText: 'Join Now', path: '/participants/google', gradient: 'linear-gradient(45deg, #4285F4, #357ABD)', hoverGradient: 'linear-gradient(45deg, #357ABD, #2A62A0)' },
  { title: 'Team Up with Microsoft', text: 'Innovate with Microsoft.', buttonText: 'Join Now', path: '/participants/microsoft', gradient: 'linear-gradient(45deg, #00A4EF, #0086C9)', hoverGradient: 'linear-gradient(45deg, #0086C9, #0068A3)' },
  { title: 'Work with IBM', text: 'Build solutions with IBM.', buttonText: 'Join Now', path: '/participants/ibm', gradient: 'linear-gradient(45deg, #1A73E8, #135ABF)', hoverGradient: 'linear-gradient(45deg, #135ABF, #0F4A9C)' },
  { title: 'Collaborate with AWS', text: 'Leverage AWS for AI.', buttonText: 'Join Now', path: '/participants/aws', gradient: 'linear-gradient(45deg, #FF9900, #D98200)', hoverGradient: 'linear-gradient(45deg, #D98200, #B36B00)' },
];

const FloatingAdverts = ({ advertsVisible, currentCompanyIndex, handleCloseAdvert, togglePopup, popupVisible }) => {
  return (
    <>
      <div className="floating-adverts" style={{ position: 'fixed', top: '100px', left: '20px', zIndex: 1000 }}>
        {staticAdverts.map((ad, index) => (
          advertsVisible[index] && (
            <div
              key={index}
              className="advert-item animated-advert"
              style={{
                width: '200px',
                background: ad.gradient,
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                color: '#fff',
                position: 'relative',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = ad.hoverGradient;
                e.currentTarget.style.transform = 'translateX(10px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = ad.gradient;
                e.currentTarget.style.transform = 'translateX(0)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              <Button
                shape="circle"
                icon={<CloseOutlined />}
                size="small"
                onClick={() => handleCloseAdvert(index)}
                style={{
                  position: 'absolute',
                  top: '8px',
                  right: '8px',
                  background: 'rgba(255,255,255,0.2)',
                  border: 'none',
                  color: '#fff',
                }}
              />
              <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 'bold' }}>{ad.title}</h3>
              <p style={{ margin: '0 0 12px 0', fontSize: '12px', lineHeight: '1.4' }}>{ad.text}</p>
              <Link to={ad.path}>
                <Button
                  style={{
                    background: 'rgba(255,255,255,0.9)',
                    border: 'none',
                    borderRadius: '6px',
                    color: '#1a1a1a',
                    fontWeight: 'bold',
                    width: '100%',
                    height: '32px',
                    transition: 'all 0.3s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#fff';
                    e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255,255,255,0.9)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  {ad.buttonText}
                </Button>
              </Link>
            </div>
          )
        ))}
        {/* Company Adverts remain unchanged */}
        {advertsVisible[2] && (
          <div
            key="company-ad"
            className="advert-item animated-advert company-ad"
            style={{
              width: '200px',
              background: companyAdverts[currentCompanyIndex].gradient,
              borderRadius: '8px',
              padding: '16px',
              marginBottom: '16px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              color: '#fff',
              position: 'relative',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = companyAdverts[currentCompanyIndex].hoverGradient;
              e.currentTarget.style.transform = 'translateX(10px)';
              e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = companyAdverts[currentCompanyIndex].gradient;
              e.currentTarget.style.transform = 'translateX(0)';
              e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            }}
          >
            <Button
              shape="circle"
              icon={<CloseOutlined />}
              size="small"
              onClick={() => handleCloseAdvert(2)}
              style={{
                position: 'absolute',
                top: '8px',
                right: '8px',
                background: 'rgba(255,255,255,0.2)',
                border: 'none',
                color: '#fff',
              }}
            />
            <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 'bold' }}>
              {companyAdverts[currentCompanyIndex].title}
            </h3>
            <p style={{ margin: '0 0 12px 0', fontSize: '12px', lineHeight: '1.4' }}>
              {companyAdverts[currentCompanyIndex].text}
            </p>
            <Link to={companyAdverts[currentCompanyIndex].path}>
              <Button
                style={{
                  background: 'rgba(255,255,255,0.9)',
                  border: 'none',
                  borderRadius: '6px',
                  color: '#1a1a1a',
                  fontWeight: 'bold',
                  width: '100%',
                  height: '32px',
                  transition: 'all 0.3s ease',
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = '#fff';
                  e.target.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'rgba(255,255,255,0.9)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                {companyAdverts[currentCompanyIndex].buttonText}
              </Button>
            </Link>
          </div>
        )}
      </div>

      <Button
        className="reopen-offers-button"
        type="primary"
        shape="circle"
        icon={<LeftOutlined />}
        size="large"
        onClick={togglePopup}
        style={{
          position: 'fixed',
          top: '50%',
          right: popupVisible ? '-50px' : '10px',
          transform: 'translateY(-50%)',
          zIndex: 1001,
          transition: 'right 0.3s ease-in-out',
        }}
      />

      <style jsx global>{`
        .floating-adverts { display: flex; flex-direction: column; gap: 16px; }
        .animated-advert { animation: slideIn 0.5s ease-in-out; }
        @media (max-width: 768px) { .floating-adverts { display: none; } }
        @keyframes slideIn { 0% { opacity: 0; transform: translateX(-20px); } 100% { opacity: 1; transform: translateX(0); } }
      `}</style>
    </>
  );
};

export default FloatingAdverts;